import { type ProductReviewServiceSummaryResponseV1 } from '@redteclab/api/clients/bully'

import { type ProductPageReviewData } from '../productPageDataAssembly/assembleReviews'

/**
 * if multi-language summaries present, will take summary with language 'all',
 * otherwise will return default summary
 */
export const productReviewAccessorGetAllSummary = (
  reviewsData: ProductPageReviewData,
): ProductReviewServiceSummaryResponseV1 => {
  if (!reviewsData.allLanguagesSummaries) {
    return reviewsData.productReviews.summary
  }

  return (
    reviewsData.allLanguagesSummaries.find((it) => it.language === 'all') ??
    reviewsData.productReviews.summary
  )
}
